import React, { Suspense, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import useClientConfig from "../../../config/careers/clientConfig";

const CareersCustomFooter = (props: any) => {
    
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const {clientSiteSettings} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;

    /**
     * * @returns template from adjacent customfootertemplates folder
     * Places to add - client ids, customFooterIds in client constants 
     */

    const [menuSettings, setMenuSettings] = useState({
        id : "",
        classref : "",
        logoimg : "",
        bannerImg : "",
        artifactImg1: "",
        artifactImg2: "",
        copyrightLogo : "",
        footerLogoImg : "",
        menuType : "1",
        tiktokIcon: ""
    });

    useEffect(() => {
        let currentClientSetting:any = clientSiteSettings?.customMenuUISettings || null;   
        setMenuSettings(currentClientSetting);
    }, [clientConfig]);

    const renderFooter = () => {
        const FooterComponentLabel = clientSiteSettings?.footerComponentName;
        return (
            <Suspense fallback={<></>}>
                {React.createElement(
                    React.lazy(() =>
                        import(`./customFooterTemplates/${FooterComponentLabel}Footer`).catch(() => ({
                            default: () => <div>Not loading</div>,
                        }))
                    ),
                    { ...props, menuSettings }
                )}
            </Suspense>
        );
    };

    // this is to find the new clients - start //
    const [ isOptionFourClient, setIsOptionFourClient ] = useState<boolean>(clientSiteSettings?.optionFourClient);

    const renderClientFooter = () => {
        const FooterComponentName = templateName.charAt(0).toUpperCase()+templateName.slice(1).replace(/_/g, "");
        const isCustom = clientSiteSettings?.customClientOption;
        const folderName = isCustom ? (clientSiteSettings?.footerComponentName) : FooterComponentName + "Footer";

        return <Suspense fallback={<></>}>
            {React.createElement(React.lazy(() => import(`./customFooterTemplates/${folderName}`).catch(() => ({ default: () => <div>Not loading</div> }))), props)}
        </Suspense>;
    };
    // End //

    useEffect(() => {
        const clientScripts = clientConfig?.data?.data?.clientSettings?.clientScripts;

        if (clientScripts) {
            const footerScript = clientScripts?.footerScript ? JSON.parse(clientScripts?.footerScript) : [];

            const injectScript = (id: string, content: string, target: HTMLElement, tagType: any) => {
                if (!document.getElementById(id)) {
                    const scriptElement = document.createElement(tagType);
                    scriptElement.id = id;
                    scriptElement.textContent = content;
                    target.appendChild(scriptElement);
                }
            };

            const injectNoScript = (id: string, content: string, target: HTMLElement, tagType: string, scriptAttribute: any) => {
                if (!document.getElementById(id)) {
                    const noscriptElement = document.createElement(tagType);
                    noscriptElement.id = id;

                    const iframeElement = document.createElement("iframe");
                    iframeElement.style.display = "none";
                    iframeElement.width = scriptAttribute?.width || "0px";
                    iframeElement.height = scriptAttribute?.height || "0px";

                    if (scriptAttribute?.src) {
                        iframeElement.src = scriptAttribute.src;
                    } else {
                        const blob = new Blob([content], { type: "text/html" });
                        const blobURL = URL.createObjectURL(blob);
                        iframeElement.src = blobURL;
                        iframeElement.addEventListener("load", () => URL.revokeObjectURL(blobURL), { once: true });
                    }

                    noscriptElement.appendChild(iframeElement);
                    target.appendChild(noscriptElement);
                }
            };

            if (footerScript?.length > 0) {
                footerScript.forEach((scriptData: any, index: number) => {
                    const id = `footer-script-${index}`;
                    if (scriptData?.type === "raw") {
                        injectScript(id, scriptData.content, document.body, scriptData?.tagtype);
                    } else if (scriptData?.type === "iframe") {
                        injectNoScript(id, scriptData.content, document.body, scriptData?.tagtype, scriptData?.attributes);
                    }
                });
            }
        }
    }, [clientConfig]);

    return(
        <> 
            { isOptionFourClient ? renderClientFooter() : renderFooter() }            
        </>
    );
};


export default CareersCustomFooter;